/**
 * Navigation-related semantic tokens for PrimeNG preset
 * Includes navigation lists, items, and submenus
 */

import * as p from '../tokens/primitives.js';
import { layout } from '../tokens/semantic.js';

export const navigation = {
  // Navigation tokens
  navigation: {
    list: {
      padding: p.spacing[8],
      gap: '0',
    },
    item: {
      padding: `${layout.gap.sm} ${layout.gap.md}`,
      borderRadius: '0',
      gap: layout.gap.sm,
    },
    submenuLabel: {
      padding: `${layout.gap.sm} ${layout.gap.md}`,
      fontWeight: p.fontWeight.semibold,
    },
    submenuIcon: {
      size: p.fontSize.base,     // 1rem (16px icon size)
    },
  },
};
